module.exports = __webpack_public_path__ + "static/media/36.cdf64b33.jpg";